export enum grossReceiptTypes {
    foodBev = "BLPSGRFB",
    roomOccupancy = "BLPSGRRO",
    heavyEquipment = "BLPSGRHEQ",
    vehicle = "BLPSGRVEH"
};